import * as z from "zod";

export const LSCustomerBaseDefaultsSchema = z.object({
	result: z.number().nullable().optional(),
	phone: z.string().nullable().optional(),
	email: z.string().nullable().optional(),
	bookFormDays: z.number().nullable().optional(),
	bookFormPrice: z.boolean().nullable().optional(),
	bookFormCodes: z.array(z.string()).optional().default([]),

	itemCat: z.string().nullable().optional(),
	itemCats: z.array(z.string()).optional().default([]),

	localityID: z.string().nullable().optional(),
	// Supersedes localityID as the locality-scope key once the backend ships it.
	companyID: z.string().nullable().optional(),
	priceRateID: z.string().nullable().optional(),
	vehicleTypeID: z.string().nullable().optional(),

	lastError: z.string().optional(),
});

export type LSCustomerBaseDefaults = z.infer<typeof LSCustomerBaseDefaultsSchema>;
